module.exports = __webpack_public_path__ + "img/64.7a604de1.jpg";